// src/utils/upload.js
import store from '../../store/index';

export function getBaseHost() {
  const { host, port } = store.state.config || {};
  if (!host) return '';
  return host + (port ? ':' + port : '');
}

export function getUploadUrl(type = 'image') {
  return `${getBaseHost()}/upload/upload/${type}`;
}